import React from 'react';
import { Helmet } from 'react-helmet';

const DefaultHead = () => (
  <Helmet>
    <title>3D WebView: cross-platform web browser for Unity (Android, iOS, Windows, macOS, and UWP / Hololens) | Vuplex</title>
    <meta name="description" content="Easily add an interactive web browser to your Unity 3D scenes to display websites and HTML. Works with Android, iOS, Windows, macOS, Oculus Quest, Universal Windows Platform (UWP), and Hololens." />
  </Helmet>
);

export default DefaultHead;
